export default __webpack_public_path__ + "static/media/music-notes-jumping.3c103408.svg";